import {Outlet} from 'react-router-dom'

import Loader from '../shared/Loader'
import NotFound from '../NotFound'

import {connect} from '../../state/hooks/tools'
import {isEmpty} from '../../lib/tools'

// Authentication alone used to be enough to render the admin section, which left a signed
// in user looking at admin pages the API would then refuse to fill. The role arrives with
// the rest of the session, so hold the section until it does and show only admins in.
const AdminGateway = props => {
  const role = props.roles[0] || {}

  if (isEmpty(role))
    return props.failed ? <NotFound /> : <Loader loading />

  return role.name === 'admin' ? <Outlet /> : <NotFound />
}

const mapStateToProps = ({roles}) => ({roles: [], ...roles})

export default connect(mapStateToProps)(AdminGateway)
